import com.github.chosamuel.kishibe.math.Vector2

data class SpringParticle(var pos: Vector2){
    var fixed = false;

}

fun springParticlesFromPoints(list: List<List<Vector2>>): List<List<SpringParticle>>{
    val sp = mutableListOf<MutableList<SpringParticle>>()
    list.forEachIndexed { i, row->
        sp.add(mutableListOf<SpringParticle>())
        row.forEach{ sp[i].add(SpringParticle(it)) }
    }
    return sp
}
